import BetErrors from './_bet-errors.js'
import BetslipBet from './_betslip-bet.js'
import StakeInput from './_stake-input.js'
import FormattedLabelWithPrice from './_formatted-label-with-price.js'
import FormattedLabelWithTotalOdds from './_formatted-label-with-total-odds.js'

export default {
  name: 'LabeledBet',
  values: {
    betErrors: {
      configSet: BetErrors,
      configValues: {},
    },
    betslipBet: {
      configSet: BetslipBet,
      configValues: {
        betInfoContainer: {
          style: {
            alignItems: 'center',
          },
        },
      },
    },
    stakeInput: {
      configSet: StakeInput,
      configValues: {},
    },
    potentialTax: {
      configSet: FormattedLabelWithPrice,
      configValues: {},
    },
    totalOdds: {
      configSet: FormattedLabelWithTotalOdds,
      configValues: {
        container: {
          style: {
            padding: '2px 0 0 0',
          },
        },
      },
    },
  },
  meta: {
    extendable: false,
  },
}
